import { useQueryClient } from 'vue-query'
import { useEventBus } from './useEventBus'
import type { UserDto } from '@/api/contracts/models'
import QueryKeys from '@/vue-query/QueryKeys'

export function useFreshDesk() {
  interface FreshworksWidget {
    (action: 'hide', element: 'launcher'): void
    (action: 'open'): void
    (action: 'open', type: 'article', options: { id: string }): void
    (action: 'open', type: 'ticketForm'): void
    (
      action: 'identify',
      type: 'ticketForm',
      options: { name: string; email: string },
    ): void
  }

  const freshDesk = (
    window as unknown as { FreshworksWidget: FreshworksWidget }
  ).FreshworksWidget

  const queryClient = useQueryClient()

  const hideLauncher = () => {
    freshDesk('hide', 'launcher')
  }

  const openWidget = (articleId?: string) => {
    if (articleId) {
      freshDesk('open', 'article', { id: articleId })
    } else {
      freshDesk('open')
    }

    useEventBus().emit('helpOpened')
  }

  const openContactForm = () => {
    const userProfile = queryClient.getQueryData<UserDto>([
      QueryKeys.UserProfile,
    ])

    if (userProfile?.name && userProfile?.email) {
      freshDesk('identify', 'ticketForm', {
        name: userProfile.name,
        email: userProfile.email,
      })
    }

    freshDesk('open', 'ticketForm')
  }

  return {
    hideLauncher,
    openWidget,
    openContactForm,
  }
}
